export default __webpack_public_path__ + "static/login-bg-4253c38c1eadd0a8e49e3b28539b073c.png";